/* ==========================================================
   HALLOWEEN PDP — behaviour (vanilla JS, no dependencies)
   ========================================================== */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var digits = function (s) { return String(s || '').replace(/[^0-9]+/g, '-').replace(/^-|-$/g, ''); };

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var noDec = String(Math.round(cents / 100));
    format = format || '${{amount}}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  }
  var fmtDay = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };

  /* ---------------- gallery ---------------- */
  function initGallery(root) {
    var track = $('.hw-gallery__track', root);
    if (!track) return null;
    var slides = $$('.hw-gallery__slide', root);
    var thumbs = $$('.hw-gallery__thumb', root);
    var dots = $$('.hw-gallery__dots span', root);
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    function go(i, smooth) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== current) setActive(i);
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prev = $('.hw-gallery__arrow--prev', root), next = $('.hw-gallery__arrow--next', root);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    return {
      goToMedia: function (mediaId) {
        var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
        if (idx > -1) go(idx);
      }
    };
  }

  /* ---------------- product form ---------------- */
  function initProduct(root) {
    var dataEl = $('script[data-hw-product]', root);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var moneyFormat = root.dataset.moneyFormat;
    var gallery = initGallery(root);
    var form = $('form[data-hw-form]', root);
    var idInput = $('input[name="id"]', form);
    var qtyInput = $('input[name="quantity"]', form);
    var atcBtns = $$('[data-hw-atc]', root);
    var msg = $('.hw-atc__msg', root);
    var redirect = root.dataset.afterAdd || 'cart';
    var lowStock = parseInt(root.dataset.lowStock || '0', 10);
    var inventory = {};
    try { inventory = JSON.parse(($('script[data-hw-inventory]', root) || {}).textContent || '{}'); } catch (e) {}

    function selected() {
      return product.options.map(function (_, i) {
        var checked = $('input[data-hw-option="' + i + '"]:checked', root);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
    }

    function refreshAvailability(opts) {
      // For each option value, grey it out if no available variant exists with the other current selections.
      product.options.forEach(function (_, i) {
        $$('input[data-hw-option="' + i + '"]', root).forEach(function (input) {
          var test = opts.slice(); test[i] = input.value;
          var v = findVariant(test);
          input.closest('label').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function update() {
      var opts = selected();
      var v = findVariant(opts);
      refreshAvailability(opts);
      product.options.forEach(function (_, i) {
        var out = $('[data-hw-option-value="' + i + '"]', root);
        if (out) out.textContent = opts[i] || '';
      });
      if (!v) {
        atcBtns.forEach(function (b) { b.disabled = true; b.querySelector('[data-hw-atc-label]').textContent = 'Unavailable'; });
        return;
      }
      idInput.value = v.id;
      var qty = parseInt(qtyInput.value, 10) || 1;
      var tier = $('input[name="hw-tier"]:checked', root);
      var tierOff = tier ? parseFloat(tier.dataset.discount || '0') : 0;
      var total = Math.round(v.price * qty * (1 - tierOff / 100));

      $$('[data-hw-price]', root).forEach(function (el) { el.textContent = money(v.price, moneyFormat); });
      var was = $('[data-hw-compare]', root), save = $('[data-hw-save]', root);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (was) { was.textContent = money(v.compare_at_price, moneyFormat); was.hidden = false; }
        if (save) { save.textContent = save.dataset.prefix + ' ' + Math.floor((1 - v.price / v.compare_at_price) * 100) + '% OFF'; save.hidden = false; }
      } else {
        if (was) was.hidden = true;
        if (save) save.hidden = true;
      }
      $$('[data-hw-tier-price]', root).forEach(function (el) {
        var q = parseInt(el.dataset.qty, 10), off = parseFloat(el.dataset.discount || '0');
        el.innerHTML = money(Math.round(v.price * q * (1 - off / 100)), moneyFormat) +
          (off > 0 ? '<s>' + money(v.price * q, moneyFormat) + '</s>' : '');
      });

      atcBtns.forEach(function (b) {
        b.disabled = !v.available;
        b.querySelector('[data-hw-atc-label]').textContent = v.available
          ? (b.dataset.label + ' — ' + money(total, moneyFormat))
          : 'Sold out';
      });

      var stock = $('.hw-stock', root);
      if (stock) {
        var inv = inventory[v.id];
        var txt = $('.hw-stock__txt', stock);
        if (!v.available) { stock.hidden = true; }
        else if (typeof inv === 'number' && inv > 0 && inv <= lowStock) {
          stock.hidden = false; stock.classList.add('is-low');
          txt.textContent = 'Only ' + inv + ' left in this size';
        } else {
          stock.hidden = false; stock.classList.remove('is-low');
          var pd = root.dataset.processing || '1';
          txt.textContent = pd === '0'
            ? 'In stock — order before ' + (root.dataset.cutoffLabel || '2pm') + ', ships today'
            : 'In stock — ships within ' + pd + (pd === '1' ? ' business day' : ' business days');
        }
      }

      if (v.featured_media && gallery) gallery.goToMedia(v.featured_media.id);
      var stickyImg = $('.hw-sticky__img', root);
      if (stickyImg && v.featured_image) stickyImg.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      var stickyVar = $('[data-hw-sticky-variant]', root);
      if (stickyVar) stickyVar.textContent = v.title;

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    $$('input[data-hw-option]', root).forEach(function (i) { i.addEventListener('change', update); });

    // bundle tiers
    $$('input[name="hw-tier"]', root).forEach(function (r) {
      r.addEventListener('change', function () {
        qtyInput.value = r.value;
        $$('.hw-tier', root).forEach(function (t) { t.classList.toggle('is-checked', t.contains(r)); });
        update();
      });
    });

    // add to cart
    function addToCart(e) {
      if (e) e.preventDefault();
      var btn = atcBtns[0];
      atcBtns.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
      msg.textContent = ''; msg.classList.remove('is-error');
      var drawer = document.querySelector('cart-drawer');
      var useDrawer = redirect === 'cart' && drawer && typeof drawer.renderContents === 'function';
      var payload = { items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }] };
      if (useDrawer) { payload.sections = 'cart-drawer,cart-icon-bubble'; payload.sections_url = window.location.pathname; }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          if (useDrawer && res.body.sections) {
            drawer.classList.remove('is-empty');
            try { drawer.renderContents(res.body); } catch (e) { window.location.href = '/cart'; return; }
            atcBtns.forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
            return;
          }
          window.location.href = redirect === 'checkout' ? '/checkout' : '/cart';
        })
        .catch(function (err) {
          msg.textContent = err.message; msg.classList.add('is-error');
          atcBtns.forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
        });
    }
    form.addEventListener('submit', addToCart);
    var sticky = $('.hw-sticky', root);
    if (sticky) {
      $('[data-hw-atc]', sticky).addEventListener('click', addToCart);
      var mainBtn = $('[data-hw-atc]', form);
      var ticking = false;
      var checkSticky = function () {
        ticking = false;
        sticky.classList.toggle('is-visible', mainBtn.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(checkSticky); }
      }, { passive: true });
      checkSticky();
    }

    // size finder
    var finder = $('.hw-finder', root);
    var sizeData = [];
    try { sizeData = JSON.parse(($('script[data-hw-sizes]') || {}).textContent || '[]'); } catch (e) {}
    if (finder && sizeData.length) {
      var w = $('[data-hw-weight]', finder), h = $('[data-hw-height]', finder), out = $('.hw-finder__out', finder);
      var runFinder = function () {
        var wt = parseFloat(w.value), ht = parseFloat(h.value);
        if (!wt && !ht) { out.innerHTML = 'Enter weight and/or height and we’ll pick the size.'; return; }
        var idx = sizeData.findIndex(function (s) {
          return (!wt || wt <= s.weight_lb) && (!ht || ht <= s.height_in);
        });
        if (idx === -1) { out.innerHTML = 'Your little one is bigger than our largest size (' + sizeData[sizeData.length - 1].label + '). Message us and we’ll help.'; return; }
        var s = sizeData[idx];
        var nearTop = (wt && wt > s.weight_lb * 0.9) || (ht && ht > s.height_in * 0.95);
        if (nearTop && sizeData[idx + 1]) s = sizeData[idx + 1];
        out.innerHTML = 'We recommend <strong>' + s.label + '</strong>' + (nearTop ? ' — they’re near the top of the smaller size, so we sized up for room.' : '.');
        // auto-select matching size option
        // match on the upper age bound so "12-18 Months" also matches "13-18 M"
        var target = digits(s.label).split('-').pop();
        $$('input[data-hw-option]', root).forEach(function (input) {
          var d = digits(input.value);
          if (d.indexOf('-') > -1 && d.split('-').pop() === target) { input.checked = true; input.dispatchEvent(new Event('change')); }
        });
      };
      w.addEventListener('input', runFinder);
      h.addEventListener('input', runFinder);
    }

    // delivery estimate
    var del = $('.hw-delivery', root);
    if (del) {
      var now = new Date();
      var cutoffHour = parseInt(del.dataset.cutoffHour || '14', 10);
      var start = new Date(now);
      if (now.getHours() >= cutoffHour || now.getDay() === 0 || now.getDay() === 6) start = addBusinessDays(now, 1);
      var ship = addBusinessDays(start, parseInt(del.dataset.processing || '1', 10));
      var min = addBusinessDays(ship, parseInt(del.dataset.min || '4', 10));
      var max = addBusinessDays(ship, parseInt(del.dataset.max || '7', 10));
      var halloween = new Date(del.dataset.halloween + 'T23:59:59');
      var txt = $('.hw-delivery__txt', del);
      var range = fmtDay(min) === fmtDay(max) ? fmtDay(max) : fmtDay(min) + ' – ' + fmtDay(max);
      if (max <= halloween) {
        txt.innerHTML = '<strong>🎃 Arrives before Halloween</strong> — order today, delivered ' + range + '.';
      } else if (min <= halloween) {
        txt.innerHTML = '<strong>🎃 Order today for Halloween</strong> — estimated delivery ' + range + '.';
      } else {
        del.classList.add('is-late');
        txt.innerHTML = 'Order today → arrives <strong>' + range + '</strong>. This will arrive after Halloween — still perfect for photos & dress-up.';
      }
    }

    update();
  }

  /* ---------------- countdown ---------------- */
  function initCountdown(el) {
    var end = new Date(el.dataset.end + 'T23:59:59').getTime();
    var boxes = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
    function tick() {
      var diff = Math.max(0, end - Date.now());
      boxes.d.textContent = Math.floor(diff / 864e5);
      boxes.h.textContent = String(Math.floor(diff / 36e5) % 24).padStart(2, '0');
      boxes.m.textContent = String(Math.floor(diff / 6e4) % 60).padStart(2, '0');
      boxes.s.textContent = String(Math.floor(diff / 1e3) % 60).padStart(2, '0');
      if (diff === 0) { var wrap = el.closest('[data-hw-timing]'); if (wrap) wrap.classList.add('is-passed'); return; }
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------------- size guide unit toggle ---------------- */
  function initUnits(root) {
    var btns = $$('[data-hw-unit]', root);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        var metric = b.dataset.hwUnit === 'metric';
        $$('[data-in]', root).forEach(function (td) {
          td.textContent = metric ? td.dataset.cm : td.dataset.in;
        });
      });
    });
  }

  /* ---------------- order tracking ---------------- */
  function initTracking(root) {
    var tabs = $$('[data-hw-tab]', root);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        $$('[data-hw-pane]', root).forEach(function (p) { p.hidden = p.dataset.hwPane !== t.dataset.hwTab; });
      });
    });
    var form = $('[data-hw-track-form]', root);
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var num = $('input', form).value.trim().replace(/\s+/g, '');
      var out = $('.hw-track-result', root);
      if (!num) return;
      out.innerHTML = '<div id="hw-yq" style="min-height:560px"></div>' +
        '<p class="hw-note">Not loading? <a class="hw-link" target="_blank" rel="noopener" href="https://t.17track.net/en#nums=' + encodeURIComponent(num) + '">Open the tracking page in a new tab →</a></p>';
      var run = function () {
        if (window.YQV5) {
          window.YQV5.trackSingle({ YQ_ContainerId: 'hw-yq', YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: num });
        }
      };
      if (window.YQV5) run();
      else {
        var s = document.createElement('script');
        s.src = 'https://www.17track.net/externalcall.js';
        s.onload = run;
        document.body.appendChild(s);
      }
    });
  }

  function boot() {
    $$('[data-hw-pdp]').forEach(initProduct);
    $$('[data-hw-countdown]').forEach(initCountdown);
    $$('[data-hw-units]').forEach(initUnits);
    $$('[data-hw-tracking]').forEach(initTracking);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
